export default "__VITE_ASSET__Bg5Tq9vF__"